<template>
	<main>				
		<article>
			<files-gallery 
					v-if="page.files.length > 0" 
					:settings="slideshowSettings"
					:listing="files" 
					:pageable="false" 
					:animate="false" />
		</article>

		<div>
			<article class="page-body">
				<section v-html="page.body" />
			</article>
		</div>
		
		<div>
			<product-listing />	
			<snippet-content slug="suppliers" />
			<snippet-content slug="services" />
		</div>
	</main>
</template>

<script>
import ProductListing from '@/features/products/components/public/ProductListing'
import FilesGallery from '@/features/files/components/public/FilesGallery'
import { pagesComputed } from '@/features/pages/store'
export default {
	components: {
		FilesGallery,
		ProductListing
	},
	computed: {
        ...pagesComputed,
        page() {            
            return this.pages.find(temp => temp.slug == 'home')
        },
		files() {
			if (this.page) {
				let temp = [...this.page.files]
				return temp.sort((a,b) => a.position > b.position)
			}
			else return []
		},
		slideshowSettings() {
			try {
				return this.page.settings.slideshow
			}
			catch(e) {
				return false
			}
		}
    }
}
</script>

